export default {
    CenterBox: () => import("./components/CenterBox"),
    RedBox: () => import("./components/RedBox"),
    EditableField: () => import("./components/EditableField"),
    EditableSection: () => import("./components/EditableSection"),
    MyEditor: () => import("./components/MyEditor"),
}
